import { deviceIsDesktop } from "../common/checkDevice";

export function scene6() {
  const scene = document.querySelector(".scene-6");
  const content = scene?.querySelector(".content_text");
  if (!scene || !content) return;

  gsap.registerPlugin(SplitText, ScrollTrigger);

  // Sequence config
  const SEQ = {
    basePath: "/custom/images/animations-image-seq/crown/",
    totalFrames: 50, // 00..49
    fps: 36,
    pad: 2,
    ext: "webp",
    firstFrame: 0,
  };

  // ---- wrapper & base image (will remove base) ----
  const wrap = scene.querySelector(".article_block_item_img");
  if (!wrap) return;
  wrap.style.position = wrap.style.position || "relative";

  // Find the first <img> inside the wrap that's NOT our overlay
  const baseImg = wrap.querySelector(":scope > img:not(.scene6-crown)");
  if (baseImg) {
    // 1) Lock layout: set aspect-ratio on the wrapper using the base image's natural size
    const lockRatio = () => {
      // Prefer natural sizes (works after image loaded)
      const w = baseImg.naturalWidth;
      const h = baseImg.naturalHeight;
      if (w && h) {
        // Modern browsers: aspect-ratio preserves height as width changes
        wrap.style.aspectRatio = `${w} / ${h}`;
        wrap.style.height = ""; // clear any fixed height if previously set
      } else {
        // Fallback: freeze current height once
        const box = wrap.getBoundingClientRect();
        if (box.height) {
          wrap.style.height = box.height + "px";
        }
      }
    };

    if (baseImg.complete) {
      lockRatio();
    } else {
      baseImg.addEventListener("load", lockRatio, { once: true });
      baseImg.addEventListener("error", lockRatio, { once: true });
    }

    // 2) Remove the base image
    baseImg.remove();
  }

  // Clean old overlays if any
  wrap.querySelectorAll(".scene6-crown").forEach((n) => n.remove());

  // ---- inject the crown overlay (animated via makeImageSequence) ----
  const crown = document.createElement("img");
  crown.className = "scene6-crown";
  crown.alt = "Crown";
  crown.decoding = "async";
  crown.loading = "eager";
  crown.src = `${SEQ.basePath}${String(SEQ.firstFrame).padStart(SEQ.pad, "0")}.${SEQ.ext}`;
  Object.assign(crown.style, {
    position: "absolute",
    inset: "0",
    zIndex: "3",
    width: "auto",
    height: "100%",
    objectFit: "contain",
    pointerEvents: "none",
    opacity: "0",
    transform: "scale(0.98)",
    transition: "opacity .45s ease, transform .6s ease",
  });
  wrap.appendChild(crown);

  // ---- text lines split ----
  const split = new SplitText(content, { type: "lines" });
  gsap.set(split.lines, { opacity: 0, y: 20 });

  // ---- image-sequence controller (expects window.makeImageSequence from earlier) ----
  let seq = null;
  if (window.makeImageSequence) {
    seq = window.makeImageSequence({
      target: crown,
      totalFrames: SEQ.totalFrames,
      fps: SEQ.fps,
      mode: "once",
      basePath: SEQ.basePath,
      pad: SEQ.pad,
      ext: SEQ.ext,
    });
    seq.goto?.(SEQ.firstFrame);
  } else {
    console.warn("makeImageSequence not found; crown will render as static.");
  }

  const decodeImg = (img) => (img?.decode ? img.decode().catch(() => {}) : Promise.resolve());
  const isDesktop = deviceIsDesktop();
  const prefersReduced = matchMedia?.("(prefers-reduced-motion: reduce)")?.matches;

  // ---- play once on enter ----
  gsap.timeline({
    scrollTrigger: {
      trigger: scene,
      start: isDesktop ? "top 75%" : "top 90%",
      toggleActions: "play none none none",
      once: true,
      onEnter: async () => {
        // Ensure first crown frame is decoded (wrapper size is already locked)
        await decodeImg(crown);

        if (prefersReduced) {
          seq?.goto?.(SEQ.totalFrames - 1);
          crown.style.opacity = "1";
          crown.style.transform = "scale(1)";
        } else {
          gsap.to(crown, { opacity: 1, transform: "scale(1)", duration: 0.5, ease: "power2.out" });
          seq?.play?.();
        }

        // Reveal lines
        gsap.to(split.lines, {
          opacity: 1,
          y: 0,
          duration: 0.6,
          stagger: 0.06,
          ease: "power1.out",
          delay: 0.05,
        });
      },
    },
  });
}

// code before changing video to images
// ====================================
// ====================================
// ====================================
// ====================================
// ====================================
// ====================================
// ====================================
// ====================================

// // === shared helpers (same shape as scene-1) =========================
// function canPlay(type) {
//   const v = document.createElement("video");
//   return !!v.canPlayType && v.canPlayType(type).replace(/no/, "");
// }

// const supportsWebM = !!canPlay('video/webm; codecs="vp9,vorbis"') || !!canPlay('video/webm; codecs="vp8,vorbis"');

// const isIOSWebKit = /iPad|iPhone|iPod/.test(navigator.userAgent) || (navigator.platform === "MacIntel" && navigator.maxTouchPoints > 1);

// function awaitFirstFrame(video) {
//   if (!video) return Promise.resolve();
//   if ("requestVideoFrameCallback" in video) {
//     return new Promise((res) => video.requestVideoFrameCallback(() => res()));
//   }
//   if (video.readyState >= 2) return Promise.resolve();
//   return new Promise((res) => {
//     const on = () => {
//       video.removeEventListener("loadeddata", on);
//       video.removeEventListener("canplay", on);
//       res();
//     };
//     video.addEventListener("loadeddata", on, { once: true });
//     video.addEventListener("canplay", on, { once: true });
//     try {
//       video.load();
//     } catch {}
//   });
// }

// function hardPrime(video) {
//   if (!video) return;
//   video.muted = true;
//   video.setAttribute("muted", "");
//   video.autoplay = true;
//   video.setAttribute("autoplay", "");
//   video.playsInline = true;
//   video.setAttribute("playsinline", "");
//   video.setAttribute("webkit-playsinline", "");
//   try {
//     video.currentTime = 0;
//   } catch {}
// }

// async function primeAndPlay(video) {
//   if (!video) return;
//   hardPrime(video);
//   try {
//     await video.play();
//   } catch {}
//   await awaitFirstFrame(video).catch(() => {});
// }

// function wireVideoFallback(video, fallback) {
//   if (!video || !fallback) return;

//   fallback.style.display = "none";
//   let shown = false;
//   let firstFrame = false;
//   let timeoutId = null;

//   const hideFallback = () => {
//     firstFrame = true;
//     if (timeoutId) {
//       clearTimeout(timeoutId);
//       timeoutId = null;
//     }
//     if (shown) {
//       shown = false;
//       fallback.style.display = "none";
//     }
//   };

//   const showFallback = () => {
//     if (firstFrame) return;
//     shown = true;
//     fallback.style.display = "";
//     fallback.style.position = "absolute";
//     fallback.style.zIndex = "4";
//     fallback.style.objectFit = "contain";
//   };

//   if ("requestVideoFrameCallback" in video) {
//     video.requestVideoFrameCallback(() => hideFallback());
//   }
//   video.addEventListener("loadeddata", hideFallback, { once: true });
//   video.addEventListener("playing", hideFallback, { once: true });
//   video.addEventListener("canplaythrough", hideFallback, { once: true });

//   video.addEventListener("error", showFallback, { once: true });
//   video.addEventListener("stalled", showFallback, { once: true });
//   video.addEventListener("emptied", showFallback, { once: true });
//   video.addEventListener("abort", showFallback, { once: true });

//   timeoutId = setTimeout(showFallback, 2000);
// }

// // === SCENE 6 (lines animate on trigger, no scrub) ===================
// import { deviceIsDesktop } from "../common/checkDevice";

// export function scene6() {
//   const scene = document.querySelector(".scene-6");
//   const content = scene?.querySelector(".content_text");
//   if (!scene || !content) return;

//   function isSafari() {
//     const ua = navigator.userAgent;
//     const isSafariUA = /^((?!chrome|android).)*safari/i.test(ua);
//     const isIOSWK = /iPad|iPhone|iPod/.test(ua) || (navigator.platform === "MacIntel" && navigator.maxTouchPoints > 1);
//     return isSafariUA || isIOSWK;
//   }

//   // Inject <video> + fallback
//   (function injectVideoWithFallback() {
//     const img = scene.querySelector(".article_block_item_img img");
//     if (!img) return;
//     const wrap = img.parentElement;
//     wrap.style.position = "relative";

//     const baseStyle = "pointer-events:none;opacity:0;position:absolute;inset:0;z-index:3;width:100%;height:100%;object-fit:contain;";
//     const sources = (() => {
//       if (supportsWebM && !isIOSWebKit && !isSafari()) {
//         return `
//           <source src="/custom/images/webm/crown-new.webm" type="video/webm">
//           <source src="/custom/images/webm/crown-new-safari.mov" type='video/mp4; codecs="hvc1"'>
//         `;
//       }
//       return `
//         <source src="/custom/images/webm/crown-new-safari.mov" type='video/mp4; codecs="hvc1"'>
//       `;
//     })();

//     wrap.innerHTML = `
//       <video id="crown" muted playsinline webkit-playsinline autoplay preload="auto" style="${baseStyle}">
//         ${sources}
//       </video>
//       <img class="video-fallback video-fallback--crown" src="/custom/images/webm/covers/crown.webp" alt=""
//            style="position:absolute;inset:0;z-index:2;width:100%;height:100%;object-fit:contain;display:none;">
//     `;
//   })();

//   const crownVideo = scene.querySelector("#crown");
//   const crownFB = scene.querySelector(".video-fallback--crown");
//   wireVideoFallback(crownVideo, crownFB);
//   if (crownVideo) {
//     crownVideo.style.opacity = "0";
//     crownVideo.style.transition = "opacity 0.25s ease";
//     hardPrime(crownVideo);
//   }

//   gsap.registerPlugin(SplitText, ScrollTrigger);

//   // Split lines and set initial state
//   const split = new SplitText(content, { type: "lines" });
//   gsap.set(split.lines, { opacity: 0, y: 20 });

//   const isDesktop = deviceIsDesktop();

//   if (isDesktop) {
//     // ✅ Animate ALL lines when the trigger fires (no scrub, no pin)
//     gsap
//       .timeline({
//         scrollTrigger: {
//           trigger: scene,
//           start: "top 75%",
//           toggleActions: "play none none none",
//           once: true,
//         },
//       })
//       .to(split.lines, {
//         opacity: 1,
//         y: 0,
//         duration: 0.6,
//         stagger: 0.06,
//         ease: "power1.out",
//       });

//     // Start the video once the scene enters (independent of text animation)
//     ScrollTrigger.create({
//       trigger: scene,
//       start: "top 80%",
//       once: true,
//       onEnter: async () => {
//         if (!crownVideo) return;
//         try {
//           crownVideo.currentTime = 0;
//         } catch {}
//         await primeAndPlay(crownVideo);
//         crownVideo.style.opacity = "1";
//         if (crownFB) crownFB.style.display = "none";
//       },
//     });
//   } else {
//     // Mobile: also non-scrubbed; animate once on enter
//     ScrollTrigger.normalizeScroll(true);

//     gsap
//       .timeline({
//         scrollTrigger: {
//           trigger: scene,
//           start: "top 90%",
//           toggleActions: "play none none none",
//           once: true,
//           onEnter: async () => {
//             if (!crownVideo) return;
//             try {
//               crownVideo.currentTime = 0;
//             } catch {}
//             crownVideo.style.opacity = "1";
//             setTimeout(() => crownVideo.play?.().catch(() => {}), 100);
//           },
//         },
//       })
//       .to(split.lines, {
//         opacity: 1,
//         y: 0,
//         duration: 0.6,
//         stagger: 0.06,
//         ease: "power1.out",
//       });
//   }

//   // Resume video if tab becomes visible again
//   document.addEventListener("visibilitychange", () => {
//     if (!document.hidden && crownVideo) {
//       try {
//         crownVideo.play?.().catch(() => {});
//       } catch {}
//     }
//   });
// }
